module.exports = __webpack_public_path__ + "img/snv-outsider.5b5cae7f.png";